import React from 'react';

import { Container } from '@material-ui/core';

import { Translate } from '@hydra/common/components';
import EditorFormRow from '@hydra/routes/pdf-editor/components/EditorFormRow/EditorFormRow';
import EditorInline from '@hydra/routes/pdf-editor/components/EditorFormRow/EditorInline';
import FormToggle from '@hydra/routes/pdf-editor/components/FormToggle';
import Header from '@hydra/routes/pdf-editor/components/Header';
import HelpText from '@hydra/routes/pdf-editor/components/HelpText';

export const TabTraffic = ({
  template,
  editing,
  saveFormField,
  headerLocked,
  featuresLocked
}) => {
  return (
    <>
      <Header title='pdf_editor_tab_traffic' hasLockedButton={headerLocked} />
      <Container>
        <EditorFormRow
          label={<Translate content='pdf_editor_add_traffic_data' />}
          help={<HelpText content='pdf_editor_option_help_traffic_data' />}
          locked={featuresLocked}
          hasLockedButton={featuresLocked}
        >
          <EditorInline
            Component={FormToggle}
            field='trafficData.enabled'
            value={template.trafficData.enabled}
            otherFieldOpen={(editing !== null && editing !== 'trafficData.enabled')}
            locked={featuresLocked}
            saveFormField={({ value }) => saveFormField({
              field: 'trafficData',
              value: {
                ...template.trafficData,
                enabled: value
              }
            })}
          />
        </EditorFormRow>
      </Container>
    </>
  );
};

export default React.memo(TabTraffic);
